import React from 'react';
import { Field, FieldArray } from 'redux-form';
import Paper from 'material-ui/Paper';
import FlatButton from 'material-ui/FlatButton';
import RadioButton from 'material-ui/RadioButton';
import MenuItem from 'material-ui/MenuItem';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import { Grid, Row, Col } from 'react-flexbox-grid';
import {
    SelectField,
    TextField,
    Checkbox,
    Toggle,
    RadioButtonGroup
} from 'redux-form-material-ui'
import MenuPage from "../../pages/MenuPage";

import './ReportForm.css'

export const executionTypes = {
    DAY_IN_MONTH: 'dayInMonth',
    WEEKDAY: 'weekday'
};

export const contentType = {
    ALL: 'all',
    RELATIVE: 'relative'
};

export const reportTypes = {
    PDF: 'PDF',
    EXCEL: 'EXCEL',
    CSV: 'CSV'
};

export const relativeTypes = {
    DAY: 'DAY',
    WEEK: 'WEEK',
    MONTH: 'MONTH'
};

const relativeTypesAsList = Object.keys(relativeTypes);

const reportTypesAsList = Object.keys(reportTypes);

export const reports = ['TRANSACTION', 'BALANCE', 'OPERATOR'];
const days = [...Array(32).keys()].filter(i => i !== 0);
export const weekdays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

const ReportForm = (props) => {
    const {handleSubmit, formValues, strings, reportConfig, saving, saved} = props;
    const {Enabled, NextExecution, Update, Title, Reports, ReportSaved,
        Execution, ExecutionTypeMonth, ExecutionTypeWeekDay, ExecutionDay, ExecutionTime, ExecutionTimePattern,
        Content, ContentTypeSinceLast, ContentTypeRelative, ContentRelativeType} = props.strings;

    const renderWeekdays = ({ fields, meta: { error } }) => (
        <div>
            <ul className="report-form-weekday-list">
                {fields.map((weekday, index) => {
                    const label = `ExecutionWeekDay${weekdays[index]}`;

                    return (
                        <li key={index}>
                            <Field name={`${weekday}.checked`} value="true" component={Checkbox}
                                   label={strings[label]} />
                        </li>
                    );
                })}
            </ul>
            {error && <div className="error">{error}</div>}
        </div>
    );

    const renderReports = ({ fields, meta: { error } }) => (
        <div>
            <Table>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                    <TableRow>
                        <TableHeaderColumn>Report</TableHeaderColumn>
                        {reportTypesAsList.map(reportType => {
                            const label = `ReportType${reportType}`;

                            return (
                                <TableHeaderColumn key={reportType}>{strings[label]}</TableHeaderColumn>
                            )
                        })}
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} showRowHover={true}>
                    {fields.map((report, index) => {
                        const enabled = formValues.reports ? formValues.reports.filter(r => r.name === reports[index])[0].enabled : true;

                        const label = `Report${reports[index]}`;

                        return (
                            <TableRow key={index}>
                                <TableRowColumn>
                                    <Field name={`${report}.enabled`} value="true" component={Checkbox}
                                           label={strings[label]} />
                                </TableRowColumn>

                                {reportTypesAsList.map(reportType => {

                                    return (
                                        <TableRowColumn key={reportType}>
                                            <Field name={`${report}.reportType.${reportType}`} props={{ disabled: !enabled}} value='true' component={Checkbox}
                                                    />
                                        </TableRowColumn>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
            {error && <div className="error">{error}</div>}
        </div>
    );

    return (
        <MenuPage title={Title}>
            <div className="container">
                <form className="reportForm" onSubmit={handleSubmit}>
                    <Grid fluid>
                        <Row>
                            <Col xs={12} sm={6} md={8} lg={8} mdOffset={2} lgOffset={2} >
                                <Paper className="report-form-paper" zDepth={0}>
                                    <Field
                                        name="enabled"
                                        component={Toggle}
                                        labelPosition="right"
                                        value="true"
                                        label={Enabled}
                                    /><br /><br />

                                    {NextExecution} {reportConfig.nextExecutionTime}
                                </Paper>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={8} mdOffset={2} lgOffset={2} >
                                <h3>{Reports}</h3>

                                <FieldArray name="reports" component={renderReports} />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={8} mdOffset={2} lgOffset={2} >
                                <h3>{Execution}</h3>

                                <Paper className="report-form-paper" zDepth={0}>
                                    <Field
                                        name="executionTime"
                                        component={TextField}
                                        hintText={ExecutionTimePattern}
                                        fullWidth={true}
                                        floatingLabelText={ExecutionTime} />
                                    <br /><br />

                                    <Field name="executionType" component={RadioButtonGroup}>
                                        <RadioButton value={executionTypes.DAY_IN_MONTH} label={ExecutionTypeMonth} />
                                        <RadioButton value={executionTypes.WEEKDAY} label={ExecutionTypeWeekDay} />
                                    </Field>

                                    {
                                        formValues.executionType === executionTypes.DAY_IN_MONTH &&
                                        <div>
                                            <Field name="executionDay" component={SelectField} hintText={ExecutionDay}
                                                   fullWidth={true} floatingLabelText={ExecutionDay}>
                                                {days.map(day => (
                                                    <MenuItem key={day} value={day} primaryText={day} />
                                                ))}
                                            </Field>
                                        </div>
                                    }

                                    {
                                        formValues.executionType === executionTypes.WEEKDAY && <FieldArray name="weekday" component={renderWeekdays} />
                                    }
                                </Paper>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={8} mdOffset={2} lgOffset={2} >
                                <h3>{Content}</h3>

                                <Paper className="report-form-paper" zDepth={0}>
                                    <Field name="content" component={RadioButtonGroup}>
                                        <RadioButton value={contentType.ALL} label={ContentTypeSinceLast} />
                                        <RadioButton value={contentType.RELATIVE} label={ContentTypeRelative} />
                                    </Field>

                                    {formValues.content === contentType.RELATIVE &&

                                    <div className="report-form-relative-container">
                                        <span>{ContentRelativeType}</span>
                                        <Field name="contentRelativeNumber"
                                               component={TextField}
                                               style={{width: 70}}
                                               type="number"
                                               min="0"
                                               max="56" />

                                        <Field name="contentRelativeType" style={{width: 150}} component={SelectField}>
                                            {relativeTypesAsList.map(type => (
                                                <MenuItem key={type} value={type} primaryText={strings[`ContentRelativeType${type}`]} />
                                            ))}
                                        </Field>
                                    </div>
                                    }
                                </Paper>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={8} lg={8} mdOffset={2} lgOffset={2} style={{textAlign: 'right'}} >
                                <div className="ButtonWrapper">
                                    {saved && <span>{ReportSaved}</span>} &nbsp; &nbsp;
                                    <FlatButton
                                        type="submit"
                                        disabled={saving}
                                        backgroundColor="#fff"
                                        label={Update}
                                        fullWidth={false}/>

                                </div>
                            </Col>
                        </Row>
                    </Grid>
                </form>
            </div>
        </MenuPage>
    );
};

export default ReportForm;



// WEBPACK FOOTER //
// ./src/components/report/ReportForm.js